import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { ScheduledDropResponse } from './get-scheduled-drops';

export const cancelScheduledDropAPI = async (
  id: string,
): Promise<ScheduledDropResponse> => {
  const response = await baseAPI.delete<ScheduledDropResponse>(
    `/scheduled-drops/${id}`,
  );
  return response.data;
};

export const useCancelScheduledDrop = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: cancelScheduledDropAPI,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [KEYS.SCHEDULED_DROPS] });
    },
  });
};
